var _excluded = ["to"],
    _excluded2 = ["icon"],
    _excluded3 = ["buttonComponent", "layer", "name"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { hyperStyled } from "@macrostrat/hyper";
import { Button } from "@blueprintjs/core";
import styles from "./buttons.module.styl";
import { useAppActions, useAppState, useHashNavigate } from "../app-state";
var h = hyperStyled(styles);
export var LinkButton = function LinkButton(props) {
  var to = props.to,
      rest = _objectWithoutProperties(props, _excluded);

  var onClick = useHashNavigate(to);
  return h(Button, _objectSpread(_objectSpread({}, rest), {}, {
    onClick: onClick
  }));
};

function isIconName(x) {
  return typeof x == "string";
}

export var ListButton = function ListButton(props) {
  var icon = props.icon,
      rest = _objectWithoutProperties(props, _excluded2);

  if (!isIconName(props.icon)) {
    icon = h(props.icon, {
      size: 20
    });
  }

  return h(Button, _objectSpread(_objectSpread({}, rest), {}, {
    className: "list-button",
    icon: icon
  }));
};
export function LayerButton(props) {
  var _props$buttonComponen = props.buttonComponent,
      buttonComponent = _props$buttonComponen === void 0 ? ListButton : _props$buttonComponen,
      layer = props.layer,
      name = props.name,
      rest = _objectWithoutProperties(props, _excluded3);

  var active = useAppState(function (state) {
    return state.core.mapLayers.has(layer);
  });
  var runAction = useAppActions();

  var onClick = function onClick() {
    return runAction({
      type: "toggle-map-layer",
      layer: layer
    });
  };

  return h(buttonComponent, _objectSpread({
    active: active,
    onClick: onClick,
    text: name
  }, rest));
}